import { render, staticRenderFns } from "./SuspensefulContents.vue?vue&type=template&id=3d03f8a0"
import script from "./SuspensefulContents.vue?vue&type=script&lang=js"
export * from "./SuspensefulContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports